import Choices from "choices.js";

export default function () {
  const handleChange = (e) => {
    window.location.replace(e.target.value);
  };

  let form = document.querySelector(".handler");
  let selectors = document.querySelectorAll(".search-results__filters select");

  let options = {
    itemSelectText: "",
    searchEnabled: false,
    shouldSortItems: false,
    shouldSort: false,
  };

  if (selectors && form) {
    const filter = new Choices(".filter", options);
    const sort = new Choices(".sort", options);

    for (let i = 0; i < selectors.length; i++) {
      const element = selectors[i];
      element.addEventListener("change", function () {
        form.click();
      });
    }
  }

  if (document.querySelector(".ask-us__select-input")) {
    const askUs = new Choices(".ask-us__select-input", options);
  }

  let formSelects = document.querySelectorAll(".ajax-form select");
  for (let i = 0; i < formSelects.length; i++) {
    let ajax_options = {
      itemSelectText: "",
      searchEnabled: false,
      shouldSortItems: false,
      shouldSort: false,
      callbackOnCreateTemplates: function (template) {
        return {
          choice: (classNames, data) => {
            return template(`
				  <div class="${classNames.item} ${classNames.itemChoice} ${
              data.disabled
                ? classNames.itemDisabled
                : classNames.itemSelectable
            }" data-select-text="${this.config.itemSelectText}" data-choice ${
              data.disabled
                ? 'data-choice-disabled aria-disabled="true"'
                : "data-choice-selectable"
            } data-checkbox-if="${data.customProperties}" data-id="${
              data.id
            }" data-value="${data.value}" ${
              data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
            }>
			  ${data.value}
				  </div>
				`);
          },
        };
      },
    };
    const element = formSelects[i];
    const ci = new Choices(element, ajax_options);
  }
}
